<template>
	<div class="AddTestQuestions">
		<div class="page-header"><el-page-header @back="goBack" :content="`${$t('QuesLibrary.BankSoalanSaya')} - ${$t('QuesLibrary.CreateQuestion')}`"></el-page-header></div>
		<div class="questionBody"><Questionstype :isBank="true" :paperObj="paper" @submit="submit"></Questionstype></div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Questionstype from '@/page/myQuestionnaire/Questionstype.vue';
import Paper from '@/page/myQuestionnaire/js/Paper.js';
export default {
	name: 'AddTestQuestions',
	components: {
		Questionstype
	},
	props: {
		bankId: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			collapseVisible: ['1', '2', '3', '4'],
			typeObj: [
				{
					questionsTypeName: '常用考试题型',
					questionTypeList: [
						{
							label: '单选题',
							questionsTypeId: 100,
							icon: 'icon-danxuan_xuanzhong'
						},
						{
							label: '多选题',
							questionsTypeId: 101,
							icon: 'icon-duoxuanxuanzhong'
						},
						{
							label: '判断题',
							questionsTypeId: 102,
							icon: 'icon-icon-'
						},
						{
							label: '填空题',
							questionsTypeId: 204,
							icon: 'icon-tiankongti'
						},
						{
							label: '简答题',
							questionsTypeId: 206,
							icon: 'icon-jiandati'
						}
					]
				},
				{
					questionsTypeName: '更多题型',
					questionTypeList: [
						{
							label: '上传文件',
							questionsTypeId: 210,
							icon: 'icon-yunshangchuan'
						},
						{
							label: '多项填空',
							questionsTypeId: 207,
							icon: 'icon-tiankongti'
						},
						{
							label: '横向填空',
							questionsTypeId: 208,
							icon: 'icon-jiandati'
						},
						{
							label: '绘图题',
							questionsTypeId: 209,
							icon: 'icon-huituguanlixinxi'
						}
						// {
						//   label: "上传图片",
						//   questionsTypeId: 211,
						//   icon: 'icon-shangchuantupian'
						// },
					]
				},
				{
					questionsTypeName: '分页设置',
					questionTypeList: [
						{
							label: '一题一页',
							questionsTypeId: 404,
							icon: 'icon-xiti'
						},
						{
							label: '分页',
							questionsTypeId: 402,
							icon: 'icon-chaifenyemian'
						},
						{
							label: '段落说明',
							questionsTypeId: 401,
							icon: 'icon-duanla'
						}
					]
				}
			],
			paper: {},
			operationTimer: '',
			countDown: 60,
			createTime: ''
		};
	},
	computed: {
		...mapState(['examQuestionTypeArr']),
		id() {
			return this.$route.query.bankId;
		},
		title() {
			return this.$route.query.title;
		},
		depict() {
			return this.$route.query.depict;
		},
		isEdit() {
			return this.$route.query.isEdit;
		}
	},
	created() {
		// console.log(`题库id: ${this.id}`)
		// 初始化paper
		this.initFunction();
		if (this.isEdit) {
			// 加载试题
			this.getQuestion();
		}
	},
	mounted() {
		// 获取创建时间
		this.createTime = this.$functions.GetDate();
	},
	methods: {
		getQuestion() {
			let that = this;
			let data = {
				id: this.id
			};
			let params = {
				that: this,
				url: `${this.$config.service.examBankGetQuess}?id=${this.id}`,
				method: 'GET',
				cb(res) {
					// console.log(res)
					if (res.code == '0') {
						let paper = JSON.parse(res.resultBody.paperjson);

						for (let key in paper) {
							that.paper[key] = paper[key];
						}
						that.paper.questionsList = paper.questionsList.map(info => {
							if (that.$functions.isJSON(info)) {
								info.isedit = false
								return JSON.parse(info);
							}
							info.isedit = false
							return info;
						});
					}
				}
			};
			this.$util.request(params);
		},
		submit(state) {
			let paperJson = JSON.parse(JSON.stringify(this.paper));
			console.log(this.paper);
			let that = this;
			let data = {
				id: this.id,
				paperjson: JSON.stringify(paperJson),
				createTime: this.createTime,
				updateTime: this.$functions.GetDate(),
				bankType: 1
			};
			let params = {
				that: this,
				url: `${this.$config.service.examBankAddQuess}`,
				method: 'post',
				data: data,
				cb(res) {
					if (res.code == '0') {
						console.log();
						if (state) {
							that.goBack();
							that.$message({
								message: res.message,
								type: 'success'
							});
						}
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		initFunction() {
			//默认创建对象
			this.paper = new Paper();
			this.paper.title = this.title;
			this.paper.depict = this.depict;
		},
		goBack() {
			// this.$router.go(-1);
			// console.log('this.$route.query.back :>> ', this.$route.query.back);
			this.$router.push({
				path: '/managementIndex',
				query: {
					index: this.$route.query.back
				}
			});
		}
	},
	beforeRouteLeave(to, from, next) {
		// console.log('路由跳转')
		this.submit();
		clearTimeout(this.operationTimer);
		next();
	}
};
</script>

<style lang="scss" scoped>
.AddTestQuestions {
	height: 100%;
	background-color: #fff !important;
	.page-header {
		padding: 20px;
		background-color: rgb(255, 255, 255);
		width: 100%;
		position: fixed;
		top: 0px;
		z-index: 1000;
	}
	.form-box {
		width: 600px;
		margin: 40px auto 0 auto;
		.title {
			font-size: 16px;
			margin: 0 0 40px 30px;
		}
	}
	.questionBody {
		margin-top: 65px;
	}
}
</style>
